export default __webpack_public_path__ + "static/media/temp-8.24d660f5.svg";